export const applyRules = (number) => {
  if (typeof number !== 'number') {
    return 0;
  }

  let range = checkRange(number);
  switch (range) {
    case 999:
      return number;
    case 9999:
      return shorten(number / 1000) + 'K';
    case 999999:
      return Math.floor(number / 1000) + 'K';
    case 9999999:
      return shorten(number / 1000000) + 'M';
    default:
      return Math.floor(number / 1000000) + 'M';
  }
};
const checkRange = (number) => {
  const ranges = [999, 9999, 999999, 9999999, 999999999];

  return ranges.find((value) => number <= value);
};

const shorten = (number) => {
  const isFloat = Number(number) === number && number % 1 !== 0;
  if (!isFloat) {
    return number;
  }
  const [, int, , float] = number.toString().match(/(^\d+)(\.)(\d{0,1})/);

  return float > 0 ? `${int}.${float}` : int;
};
